module.exports = __webpack_public_path__ + "img/A_big.a816470d.png";